import { PreferencesFormModel, PreferencesModel, PreferencesStoreModel } from '@shared/models';

export const preferencesInitialValues: PreferencesFormModel = {
  timeRange: null,
  alarmCondition: '',
  alarmAcknowledge: null,
  alarmShowSystem: false,
  exportFormat: null,
  graphInterval: null,
  graphDataType: null,
  graphExportFormat: null,
  graphShowBoundariesAsPercentage: false,
  graphDigitalInterval: null,
  graphCumulativeMode: null,
  graphUnitPreferences: {},
  siteListSearchType: null,
  siteListColumnSort: null,
  siteListSortOrder: null,
};

export const mapPreferencesAPIValuesToStore = (preferences: PreferencesModel): PreferencesStoreModel => {
  return {
    id: 1,
    ...preferences,
    unitPreferences: Object.fromEntries(
      (
        Object.entries(preferences?.graphUnitPreferences ?? {})?.map(([key, val]) =>
          val?.find((v) => v.isDefault)?.name ? [key, val.find((v) => v.isDefault).name] : []
        ) ?? []
      )
        .filter(([key, val]) => key !== undefined && val)
        .sort(([keyA], [keyB]) => {
          return keyA?.toLowerCase() > keyB?.toLowerCase() ? 1 : -1;
        })
    ),
  };
};

export const mapPreferencesStoreValuesToFrom = (preferences: PreferencesStoreModel): PreferencesFormModel => ({
  timeRange: preferences?.timeRange,
  alarmCondition: preferences?.alarmCondition,
  alarmAcknowledge: preferences?.alarmAcknowledge,
  alarmShowSystem: preferences?.alarmShowSystem,
  exportFormat: preferences?.exportFormat,
  graphInterval: preferences?.graphInterval,
  graphDataType: preferences?.graphDataType,
  graphExportFormat: preferences?.graphExportFormat,
  graphShowBoundariesAsPercentage: preferences?.graphShowBoundariesAsPercentage,
  graphDigitalInterval: preferences?.graphDigitalInterval,
  graphCumulativeMode: preferences?.graphCumulativeMode,
  graphUnitPreferences: preferences?.unitPreferences,
  siteListSearchType: preferences?.siteListSearchType,
  siteListColumnSort: preferences?.siteListColumnSort,
  siteListSortOrder: preferences?.siteListSortOrder,
});
